export default __webpack_public_path__ + "static/media/login.c2f4aee4.jpg";